import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions } from '../Dialog/Dialog';
import { Grid } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import { addNewDriver } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import * as logger from "../../../logger";
import Switch from '@material-ui/core/Switch';
import { getDriverLedger } from '../../../store/actions/homeActionCreator';
import DriverGaveAndGot from '../DriverDialogs/DriverGaveAndGot';
import { replaceCommas, numberWithCommas, checkNumberOnly, numberWithCommasInput } from '../../../utils/utils';
import { Radios, Switches, TextField } from 'mui-rff';
import { Form } from 'react-final-form';


const styles = makeStyles(theme => ({
    formRoot: {
        '& .MuiFormControl-root': {
            width: '100%',
            margin: '16px 0px'
        }
    },
    error: {
        color: 'red',
        marginBottom: 8
    },
    error1: {
        color: 'red',
    },
    buttonV2: {
        textTransform: 'none',
        color: '#0033cc',
        fontWeight: 300,
        width: '12em',
        paddingLeft: 0,
        paddingRight: 0,
        height: '2.7em',
        fontSize: '12px',
        paddingTop: '6px',
        borderRadius: '8px'
    },
    form3: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap !important',
        backgroundColor: 'white',
        marginTop: '4px',
        width: '100%'
    },
    radio1: {
        paddingRight: '4px',
        color: '#0033cc'
    },
    label1: {
        justifyContent: 'space-between',
        fontSize: 14
    },
    radioForm: {
        display: 'flex',
        flexDirection: 'row'
    },
    mtV1: {
        marginBottom: '0 !important',
    },
    mtV2: {
        marginTop: '2em !important'
    },
    mtV3: {
        marginTop: '1em !important'
    },
    divV1: {
        display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', marginTop: '1em'
    },
    fwV1: {
        fontWeight: 300
    },
    txtField: {
        "& .MuiInputBase-input": {
            textTransform: 'capitalize'
        }
    },
    marginV2: {
        marginTop: 16
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    formHelperText: {
        color: '#9ea0a5',
        fontSize: 11,
        marginTop: 4,
    },
    marginV1: {
        marginTop: 6,
        width: '100%'
    },
    textV1: {
        marginTop: 6,
        width: '100%',
        "& .MuiOutlinedInput-input": {
            textTransform: 'capitalize',
        },
    },
    radiosFormGroup: {
        "& .MuiFormGroup-root": {
            flexDirection: 'row',
            flexWrap: 'nowrap'
        }
    },
    typeRadio: {
        '& .MuiRadio-root': {
            color: '#0033cc'
        }
    },
    switch: {
        '& .Mui-checked': {
            color: '#0033cc'
        },
        '& .Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiTypography-root': {
            fontSize: 17
        },
        '& .MuiSwitch-root': {
            height: 34,
            width: 55
        },
        '& .MuiSwitch-thumb': {
            width: 16,
            height: 16
        }
    }
}))

const BlueRadio = withStyles({
    root: {
        color: '#0033cc',
        '&$checked': {
            color: '#0033cc',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const SendSmsSwitch = withStyles({
    switchBase: {
        color: "#E8E8E8",
        '&$checked': {
            color: "#0033cc",
        },
        '&$checked + $track': {
            backgroundColor: "#0033cc",
        },
    },
    checked: {},
    track: {
        backgroundColor: "#D8D8D8"
    },
})(Switch);

const AddDialog = (props) => {
    let submit;
    const { user, defaultName, defaultMethod, defaultNumber, onConfirm, dispatchAddNewParty, dispatchAddNewDriver, classes, open, onClose, onSave, defaultAmount, fromDriver, dispatchFetchAllDrivers, fromDriverNameSelect, fromTrip, balanceType, fromSingleTruckComponent, ...other } = props;
    const [dialogopen, setDialogOpen] = React.useState(open);
    const [addOpeningBalanceFlag, setAddOpeningBalanceFlag] = React.useState(false);
    const [driverId, setDriverId] = useState("");
    const [driverGaveGotDialog, setDriverGaveGotDialog] = useState(false);
    const [enableSms, setEnableSms] = useState(false);
    const [driverNameValue, setDriverNameValue] = useState(defaultName ? defaultName : "");
    const [amountValue, setAmountValue] = useState(defaultAmount ? defaultAmount : '');

    const driverLedgerRequestData = {
        fleetOwnerId: user.userInfo.entityId,
        // pageNo: 1,
        // pageSize: 10,
    };

    const initialValues = {
        name: driverNameValue ? driverNameValue : defaultName,
        phoneNumber: defaultNumber ? defaultNumber : '',
        amount: amountValue ? amountValue : defaultAmount,
        enableSMS: false,
        payType: defaultMethod ? defaultMethod : "PAY",
    }

    const inlineStyles = styles();
    const balanceTypeAddDialog = balanceType;
    // const { register, handleSubmit, control, errors } = useForm({
    //     mode: 'onChange',
    //     reValidateMode: 'onChange',
    //     defaultValues: {
    //         name: defaultName ? defaultName : '',
    //         mobile: defaultNumber ? defaultNumber : '',
    //         amount: defaultAmount ? defaultAmount : '',
    //         enableSMS: false,
    //         payType: defaultMethod ? defaultMethod : "PAY",
    //     },
    // });
    const handleFormSave = (e) => {
    }
    const handleClose = (status) => {
        onClose(false);
        setEnableSms(false);
    };
    const onSubmit = data => {

        let driverNameArray = data.name.split(" ");
        let driverNameCapitalize = [];

        if (driverNameArray && driverNameArray.length > 0) {
            driverNameArray.forEach((value) => {
                if (value) {
                    driverNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                }
            })
        }

        if (props.type == "driver") {

            var newDriverRequest = {
                name: driverNameCapitalize && driverNameCapitalize.length > 0 ? (driverNameCapitalize.join(" ")).trim() : "",
                sendSMS: data.enableSms,
                contactNumber: data.phoneNumber ? data.phoneNumber.replace("-", "") : null,
                balanceType: data.payType,
                openingBalance: data.amount ? replaceCommas(data.amount) : ""
            }

            dispatchAddNewDriver(newDriverRequest,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Add Dialog Component Dweb", "Add Driver Successfull");
                        // sendSucces("Driver Created Successfully!")
                        if (fromSingleTruckComponent) {
                            setDialogOpen(false);
                            onConfirm(data.response.id);
                        }
                        if (fromDriverNameSelect) {
                            setDriverId(data.response.id);
                            setDriverGaveGotDialog(true);
                        }
                        if (fromDriver) {
                            dispatchFetchAllDrivers(driverLedgerRequestData,
                                () => {
                                    logger.log("Drivers dWeb", "Fetch all drivers successfull");
                                    setDialogOpen(false);
                                },
                                () => {
                                    logger.log("Drivers dWeb", "Fetch all drivers failed");
                                },
                            );

                            if (!fromDriverNameSelect) {
                                onConfirm();
                            }
                        }
                        if (fromTrip) {
                            dispatchFetchAllDrivers(driverLedgerRequestData,
                                () => {
                                    handleClose();
                                    sendSucces("Driver Created Successfuly!")
                                    onConfirm(true, data.response)
                                },
                                () => {
                                },
                            );
                        }
                        setEnableSms(false);
                    }
                },
                () => {
                    logger.log("Add Dialog Component Dweb", "Add Driver Failed");
                }
            );
        }
    };

    const handleBalanceClose = () => {
        setDriverGaveGotDialog(false);
        onClose(false);
    }

    // const handleDriverName = (name) => {

    //     if (/^\s+$/.test(name)) {
    //         setDriverNameValue('');
    //     } else {
    //         setDriverNameValue(name);
    //     }

    // }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <div className={inlineStyles.title}>Driver Name</div>
                            <TextField
                                placeholder="Enter Driver Name"
                                name="name"
                                variant="outlined"
                                size="small"
                                // onChange={(e) => handleDriverName(e.target.value)}
                                fieldProps={{
                                    parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                                }}
                                className={inlineStyles.textV1}
                            />
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={inlineStyles.marginV2}>
                            <div className={inlineStyles.title}>Mobile Number</div>
                            <TextField
                                placeholder="Enter Mobile Number"
                                name="phoneNumber"
                                variant="outlined"
                                size="small"
                                fieldProps={{
                                    parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">+91</InputAdornment>
                                }}
                                className={inlineStyles.marginV1}
                            />
                            <div className={inlineStyles.formHelperText}>Optional</div>
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: !addOpeningBalanceFlag,
                field: (
                    < div className={inlineStyles.mtV2} >
                        <Button variant="outlined" className={inlineStyles.buttonV2} onClick={() => setAddOpeningBalanceFlag(true)}>
                            <span>Add Opening Balance</span>
                        </Button>
                    </div >
                ),
            },
            {
                size: 12,
                visible: addOpeningBalanceFlag,
                field: (
                    <>
                        <hr style={{ borderTop: '1px dashed grey' }} />

                        <div className={inlineStyles.title}>Opening Balance</div>
                        <Radios
                            name="payType"
                            data={[
                                { label: 'Driver has to pay', value: 'PAY' },
                                { label: 'Driver has to get', value: 'GET' }
                            ]}
                            radioGroupProps={{ row: true }}
                            formControlProps={{
                                margin: 'none',
                                className: inlineStyles.typeRadio,
                                fullWidth: true
                            }}
                        />

                    </>
                ),
            },
            {
                size: 12,
                visible: addOpeningBalanceFlag,
                field: (
                    <>
                        <div>
                            <div className={inlineStyles.title}>Amount</div>
                            <TextField
                                placeholder="Enter Amount"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => { numberWithCommasInput(e, setAmountValue) }}
                                fieldProps={{
                                    parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={inlineStyles.marginV1}
                            />
                            <div className={inlineStyles.formHelperText}>Optional</div>
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: values.phoneNumber ? (values.phoneNumber.replace("-", "")).length == 10 : "",
                field: (
                    <div className={inlineStyles.marginV2}>
                        <Switches
                            name="enableSms"
                            formControlProps={{
                                className: inlineStyles.switch
                            }}
                            data={{ label: 'Enable SMS for transactions', value: true }}
                        />
                    </div>
                ),
            }

        ]
    }

    const validate = values => {

        const errors = {}

        // let driverName = values.name ? /^[A-Za-z]+$/.test(values.name.replace(/\s+/g, '')) : "";
        let number = values.phoneNumber ? /^[5-9]{1}[0-9]{9}$/.test(values.phoneNumber.replace("-", "")) : "";

        if (values && !values.name) {
            errors.name = "Please enter valid name.";
        }
        if (values.phoneNumber && !number) {
            errors.phoneNumber = "Please enter valid 10-digit mobile number.";
        }
        if (addOpeningBalanceFlag && values.amount && !checkNumberOnly(replaceCommas(values.amount))) {
            errors.amount = "Please enter valid amount."
        }

        return errors;

    }

    return (
        <>
            <div>
                <Dialog fullWidth={true}
                    maxWidth='xs'
                    onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogopen}>
                    <DialogTitle id="add-party-dialog-title" onClose={handleClose}>
                        {props.type == "driver" &&
                            < div > Add Driver Details </div>
                        }
                    </DialogTitle>
                    <DialogContent dividers>
                        <Form
                            onSubmit={onSubmit}
                            keepDirtyOnReinitialize
                            initialValues={initialValues}
                            validate={validate}
                            id="myForm"
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                submit = handleSubmit
                                return (
                                    <form onSubmit={handleSubmit} noValidate id="myForm">
                                        <Grid container alignItems="flex-start">
                                            {getFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                            Close
                        </Button>
                        <Button className='modal-save-cta' type="submit" variant="contained"
                            // onClick={() => {
                            //     document.getElementById('myForm')
                            //         .dispatchEvent(new Event('submit', { cancelable: true }))
                            // }}
                            onClick={event => {
                                submit(event)
                            }}
                        >
                            Save changes
                        </Button>
                    </DialogActions>
                </Dialog>
            </div >

            {driverGaveGotDialog && <DriverGaveAndGot balanceType={balanceTypeAddDialog} onClose={handleBalanceClose} onOpen={driverGaveGotDialog} driverId={driverId ? driverId : ""} fromDriverListing={true} />}
        </>
    );
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchAddNewDriver: (data, onSuccess, onFailure) => dispatch(addNewDriver(data, onSuccess, onFailure)),
    dispatchFetchAllDrivers: (data, onSuccess, onFailure) => (dispatch(getDriverLedger(data, onSuccess, onFailure))),

});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddDialog);